import React from 'react';
import PropTypes from 'prop-types';
import { alpha, Box, Stack } from '@mui/material';
import { C, DETAIL_CARD_SX } from '../tokens';
import { fmtNum, fmtPct, fmtValue, prettySector } from '../formatters';
import { DataLine, SectionLabel } from '../atoms';

// Context section: sector + price / smart-money / liquidity rows.
const DetailContextCard = ({ detailDrawer, t, language, locale }) => (
  <Box sx={DETAIL_CARD_SX}>
    <Box sx={{
      px: 1.4,
      py: 1,
      bgcolor: alpha(C.cyan, 0.035),
      borderBottom: `1px solid ${alpha(C.cyan, 0.1)}`,
    }}>
      <SectionLabel>{t('breakoutCandidates.drawer.context')}</SectionLabel>
    </Box>
    <Stack
      spacing={0}
      sx={{
        px: 1.4,
        py: 0.35,
        '& > *:not(:last-child)': { borderBottom: `1px solid ${alpha(C.border, 0.8)}` },
      }}
    >
      <DataLine
        k={t('breakoutCandidates.drawer.sector')}
        v={prettySector(detailDrawer.sector, language)}
      />
      <DataLine
        k={t('breakoutCandidates.drawer.distToR20')}
        v={fmtPct(detailDrawer.price?.dist_from_resistance, 2)}
      />
      <DataLine
        k={t('breakoutCandidates.drawer.udRatio')}
        v={`${fmtNum(detailDrawer.smart_money?.up_value_ratio, 2)}x`}
      />
      <DataLine
        k={t('breakoutCandidates.drawer.accumulation')}
        v={`${detailDrawer.smart_money?.accumulation_days_10 ?? 0}/10`}
      />
      <DataLine
        k={t('breakoutCandidates.drawer.liquidity')}
        v={fmtValue(detailDrawer.liquidity?.avg_value_20d, locale)}
      />
      <DataLine
        k={t('breakoutCandidates.drawer.valueRatio')}
        v={`${fmtNum(detailDrawer.liquidity?.value_ratio, 2)}x`}
      />
      <DataLine
        k={t('breakoutCandidates.drawer.supportHold')}
        v={t('breakoutCandidates.drawer.supportHoldCount', {
          count: detailDrawer.smart_money?.support_hold_count ?? 0,
        })}
      />
    </Stack>
  </Box>
);

DetailContextCard.propTypes = {
  detailDrawer: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  t: PropTypes.func.isRequired,
  language: PropTypes.string,
  locale: PropTypes.string,
};

DetailContextCard.defaultProps = {
  language: 'en',
  locale: 'en-US',
};

export default DetailContextCard;
